import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installGlobalErrorCapture } from './debug/errorLog';

// Start capturing window errors, promise rejections, and console.error/warn
// into the in-app crash log before anything renders.
installGlobalErrorCapture();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
